// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"464":"053abcc0","528":"aae82b64","901":"49e992fb","984":"1767e12d"}[chunkId] + ".chunk.js";
};